import React, { Component } from 'react';
export default class HeaderLocationNameSeller extends Component {    
    render() {       
        let citySessionName = localStorage.getItem('cityText');
        let locationSessionName = localStorage.getItem('locationText');       
        return (
            localStorage.getItem('hasLocation') === '1' ?
                <div className="locationTextDiv">{locationSessionName}, {citySessionName !== null ? citySessionName.split(' ')[0] : ''}</div>
                : ''
        );
    }
}